
// Track navigation history (add to global JS)
document.addEventListener('DOMContentLoaded', () => {
    const STORAGE_KEY = 'smartBackHistory';
    const currentUrl = window.location.href;

    let backStack = [];
    try {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        backStack = stored ? JSON.parse(stored) : [];
    } catch (e) {}

    const lastUrl = backStack.length > 0 ? backStack[backStack.length - 1] : null;

    if (lastUrl !== currentUrl) {
        backStack.push(currentUrl);

        if (backStack.length > 50) backStack.shift(); // Limit stack size

        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(backStack));
        } catch (e) {}
    }
});

// Smart back button handler
const handleBackNavigation = () => {
    const STORAGE_KEY = 'smartBackHistory';
    let backStack = [];

    const normalizeUrl = (url) => {
        return url.split('?')[0].split('#')[0].replace(/\/+$/, '');
    }

    try {
        const stored = sessionStorage.getItem(STORAGE_KEY);
        backStack = stored ? JSON.parse(stored) : [];
    } catch (e) {}

    if (backStack.length <= 1) {
        window.location.assign('/');
        return false;
    }

    const currentUrl = backStack.pop();
    const currentBase = normalizeUrl(currentUrl);

    // go back at least 1 step
    let stepsBack = -1;

    // Keep popping the stack if the previous page has the exact same base path
    while (backStack.length > 0) {
        const prevUrl = backStack[backStack.length - 1];
        const prevBase = normalizeUrl(prevUrl);

        if (prevBase === currentBase) {
            backStack.pop();
            stepsBack--;
        } else {
            break;
        }
    }

    // If we popped everything and nothing else is left, go home
    if (backStack.length === 0) {
        window.location.assign('/');
        return false;
    }

    // Save the updated stack
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(backStack));
    } catch (e) {}

    if (stepsBack === -1) {
        window.history.back();
    } else {
        window.history.go(stepsBack);
    }

    return false;
};

window.app = window.app || {};
window.app.fns = window.app.fns || {};
window.app.fns.handleBackNavigation = handleBackNavigation;

export default handleBackNavigation;
